import {createSelector} from "reselect";
import {getAlertsState} from "../root-selectors";
import {Alert} from "../../api/types";
import {AlertsState} from "./types";

export const getCurrentAlerts = createSelector(
    [getAlertsState],
    (state: AlertsState): Alert[] => state.current
)
